import { defineMessages } from 'react-intl';

export const messages: {
	emptyStateDescription: { defaultMessage: string; description: string; id: string };
	emptyStateTitle: { defaultMessage: string; description: string; id: string };
	invalidParametersDescription: { defaultMessage: string; description: string; id: string };
	invalidParametersTitle: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	emptyStateTitle: {
		id: 'hub-forge-extension.hub-forge-empty-state.emptyStateTitle',
		defaultMessage: 'No app available',
		description:
			'Empty state title shown inside the Hub Forge extension node when no installed Forge app is available for the slot.',
	},
	emptyStateDescription: {
		id: 'hub-forge-extension.hub-forge-empty-state.emptyStateDescription',
		defaultMessage: 'You haven\u2019t installed a custom app yet.',
		description:
			'Empty state description shown inside the Hub Forge extension node when no installed Forge app is available for the slot.',
	},
	invalidParametersTitle: {
		id: 'hub-forge-extension.hub-forge-empty-state.invalidParametersTitle',
		defaultMessage: 'Forge app couldn’t load',
		description:
			'Empty state title shown inside the Hub Forge extension node in edit mode when the saved extension parameters cannot be read.',
	},
	invalidParametersDescription: {
		id: 'hub-forge-extension.hub-forge-empty-state.invalidParametersDescription',
		defaultMessage: 'Remove this app and add it again.',
		description:
			'Empty state description shown inside the Hub Forge extension node in edit mode when the saved extension parameters cannot be read.',
	},
});
